<template>
	<div class="formkit-rating">
		<div class="formkit-rating-buttons">
			<button
				v-for="value in ratingValues"
				:key="value"
				type="button"
				:class="[
					'formkit-rating-button',
					{ 'formkit-rating-button--selected': modelValue === value }
				]"
				@click="handleSelect(value)"
			>
				{{ value }}
			</button>
		</div>
	</div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
	context: {
		type: Object,
		required: true,
	},
});

const modelValue = computed(() => props.context._value);
const min = computed(() => props.context.min ?? 1);
const max = computed(() => props.context.max ?? 5);

const ratingValues = computed(() => {
	const values = [];
	for (let i = min.value; i <= max.value; i++) {
		values.push(i);
	}
	return values;
});

const handleSelect = (value) => {
	props.context.node.input(value);
};
</script>

<style scoped>
.formkit-rating {
	width: 100%;
}

.formkit-rating-buttons {
	display: flex;
	gap: 0.5rem;
	flex-wrap: wrap;
	justify-content: center;
}

.formkit-rating-button {
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 2px solid #d9d5c8;
	border-radius: 0.5rem;
	background: white;
	color: #5b6560;
	font-size: 1.125rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s;
}

.formkit-rating-button:hover {
	border-color: #6b2e93;
	color: #4b1b6b;
}

.formkit-rating-button--selected {
	background: #4b1b6b;
	border-color: #4b1b6b;
	color: white;
}

.formkit-rating-button--selected:hover {
	background: #3a1050;
	border-color: #3a1050;
}

@media (min-width: 768px) {
	.formkit-rating-button {
		width: 56px;
		height: 56px;
	}
}
</style>
